export const PAC_UNVERIFIED = "PAC_UNVERIFIED";
export const PAC_VERIFIED = "PAC_VERIFIED";
export const PAC_ERROR = "PAC_ERROR";
